/**
 * Represents the edit mode for NDC Destination termination.
 */
export enum NdcDestinationTerminationEditModeModel {
	/**
	 * No edit mode is applied.
	 */
	None = 0,
	/**
	 * Automatically sets the termination date to one day before the new effective date.
	 */
	AutoSetToNewEffectiveDateMinusOne = 1,
	/**
	 * Allows manual selection of the termination date using a date picker.
	 */
	ManualDatePicker = 2
}
